<template>
  <base-modal
      :icon="icon"
      :title="title">
    <div
        class="message"
        v-html="message"/>
    <template #footer>
      <base-button
          v-for="(button, i) in buttons"
          :key="i"
          :text="button.text"
          @click="button.func"/>
    </template>
  </base-modal>
</template>

<script>
import BaseButton from '@/components/core/BaseButton.vue';
import BaseModal from './BaseModal.vue';

export default {
  name: 'MessageModal',
  components: {
    BaseModal,
    BaseButton,
  },
  props: {
    icon: String,
    title: String,
    message: String,
    buttons: Array,
  },
};
</script>

<style lang="scss" scoped>
.message {
  padding: 0.5rem 0.625rem;
  text-align: center;
}
</style>
